/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckEligibilityDetails } from './CheckEligibilityDetails';
import {
    CheckEligibilityDetailsFromJSON,
    CheckEligibilityDetailsFromJSONTyped,
    CheckEligibilityDetailsToJSON,
    CheckEligibilityDetailsToJSONTyped,
} from './CheckEligibilityDetails';

/**
 * 
 * @export
 * @interface CheckEligibilityResponse
 */
export interface CheckEligibilityResponse {
    /**
     * Whether the action is eligible
     */
    eligible: boolean;
    /**
     * Human-readable reason when eligible is false
     */
    reason?: string;
    /**
     * 
     */
    details?: CheckEligibilityDetails;
}

/**
 * Check if a given object implements the CheckEligibilityResponse interface.
 */
export function instanceOfCheckEligibilityResponse(value: object): value is CheckEligibilityResponse {
    if (!('eligible' in value) || value['eligible'] === undefined) return false;
    return true;
}

export function CheckEligibilityResponseFromJSON(json: any): CheckEligibilityResponse {
    return CheckEligibilityResponseFromJSONTyped(json, false);
}

export function CheckEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'eligible': json['eligible'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'details': json['details'] == null ? undefined : CheckEligibilityDetailsFromJSON(json['details']),
    };
}

export function CheckEligibilityResponseToJSON(json: any): CheckEligibilityResponse {
    return CheckEligibilityResponseToJSONTyped(json, false);
}

export function CheckEligibilityResponseToJSONTyped(value?: CheckEligibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eligible': value['eligible'],
        'reason': value['reason'],
        'details': CheckEligibilityDetailsToJSON(value['details']),
    };
}

